module.exports = __webpack_public_path__ + "img/idebit.f485135e.svg";